import { apiRequest } from "../client";
import type { RefreshPlanExecuteResponse, RefreshPlanPreview, RefreshPlanPreviewRequest } from "./types";

export async function previewRefreshPlan(params: RefreshPlanPreviewRequest): Promise<RefreshPlanPreview> {
  return await apiRequest<RefreshPlanPreview>({
    method: "POST",
    url: "/agentic/data-ingestion/refresh-plan/preview",
    data: params,
  });
}

export async function executeRefreshPlan(plan: Record<string, unknown>): Promise<RefreshPlanExecuteResponse> {
  return await apiRequest<RefreshPlanExecuteResponse>({
    method: "POST",
    url: "/agentic/data-ingestion/refresh-plan/execute",
    data: { plan },
  });
}
